<template>
    <div>
        <hr/>

        <div class="dropdown-container">

            <div class="top-area" v-if="content.areas[0].content">
                <render-editor-js :content="content.areas[0].content" :component="{}"/>
            </div>

            <b-field class="text-input-field" :type="{'is-danger': missingResponse}" :message="(content.required) ? '* Response is required.' : ''">
                <div class="columns mb-0" style="width: 100%">
                    <div class="column">
                        <b-field label="District" label-position="inside" :type="{'is-danger': content.required && !hasDistrict}">
                            <b-select v-model="district_id" :required="content.required" expanded>
                                <option :value="0">Not Listed/Not Applicable</option>
                                <option :value="999999">Private School</option>
                                <option v-for="district in districts" :value="district.id">{{ district.name }} ({{ district.city | capitalize }})</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="School" label-position="inside" :type="{'is-danger': content.required && !hasSchool}">
                            <b-select v-model="school_id" :required="content.required" expanded>
                                <option :value="0">Not Listed/Not Applicable</option>
                                <option :value="school.id" v-for="school in schools">{{school.name}} ({{school.city | capitalize}})</option>
                            </b-select>
                        </b-field>
                    </div>
                </div>
            </b-field>

            <div class="bottom-area" v-if="content.areas[1].content">
                <render-editor-js :content="content.areas[1].content" :component="{}"/>
            </div>
        </div>
    </div>
</template>

<script>

    import RenderEditorJs from "./RenderEditorJs.vue";
    import {client as http} from "@/http_client";

    export default {
        components: {RenderEditorJs},
        props: ['content', 'data'],
        data: function() {
            return {
                districts: [],
                schools: [],
                district_id: undefined,
                school_id: undefined,
                restoring: false
            };
        },
        computed: {
            savedValue() {
                return this.data[this.content.id] || {};
            },
            hasDistrict() {
                return !!this.savedValue.district;
            },
            hasSchool() {
                return !!this.savedValue.school;
            },
            missingResponse() {
                return !!this.content.required && (!this.hasDistrict || !this.hasSchool);
            }
        },
        methods: {
            saveData() {
                if (this.district_id === undefined) return;

                let value = {
                    district_id: null,
                    district: null,
                    school_id: null,
                    school: null
                };

                if (this.district_id === 0) {
                    value.district = 'Not Listed/Not Applicable';
                } else if (this.district_id === 999999) {
                    value.district = 'Private School';
                } else {
                    const district = this.districts.find(d => d.id === this.district_id);
                    value.district_id = this.district_id;
                    value.district = (district) ? district.name : null;
                }

                if (this.school_id === 0) {
                    value.school = 'Not Listed/Not Applicable';
                } else if (this.school_id !== undefined) {
                    const school = this.schools.find(s => s.id === this.school_id);
                    value.school_id = this.school_id;
                    value.school = (school) ? school.name : null;
                }

                this.$set(this.data, this.content.id, value);

                this.$emit('saveData', {
                    block: JSON.stringify(this.content),
                    field: this.content.id,
                    value: JSON.stringify(value)
                });
            },
            loadSchools(districtId) {
                this.schools = [];
                const district = this.districts.find(d => d.id === districtId);
                if (!district) return Promise.resolve();

                return http.get('districts/schoolsIn/' + district.code).then(results => {
                    this.schools = results.data;
                }).catch(err => {
                    console.error(err);
                });
            },
            restore() {
                const saved = this.data[this.content.id];
                if (!saved || !saved.district) return;

                this.restoring = true;

                if (saved.district === 'Not Listed/Not Applicable' && !saved.district_id) {
                    this.district_id = 0;
                } else if (saved.district === 'Private School' && !saved.district_id) {
                    this.district_id = 999999;
                } else {
                    this.district_id = saved.district_id;
                }

                const restoreSchool = () => {
                    if (saved.school === 'Not Listed/Not Applicable' && !saved.school_id) {
                        this.school_id = 0;
                    } else if (saved.school_id) {
                        this.school_id = saved.school_id;
                    }
                    this.$nextTick(() => this.restoring = false);
                };

                if (saved.district_id) {
                    this.loadSchools(saved.district_id).then(restoreSchool);
                } else {
                    restoreSchool();
                }
            }
        },
        watch: {
            district_id(val) {
                if (this.restoring) return;
                this.schools = [];
                this.school_id = undefined;
                if (val !== 0 && val !== 999999) {
                    this.loadSchools(val);
                }
                this.saveData();
            },
            school_id(val) {
                if (this.restoring || val === undefined) return;
                this.saveData();
            }
        },
        created() {
            http.get('districts').then(results => {
                this.districts = results.data;
                this.restore();
            }).catch(err => {
                console.error(err);
            });
        }
    };
</script>

<style lang="scss" scoped>
    .dropdown-container {
        border: 1px solid transparent;
        border-radius: 0.3rem;
    }
</style>
